import { CoFounder } from "@/components/home/CoFounder";
import EditorDemoSection from "@/components/home/EditorDemoSection";
import FeaturesBento from "@/components/home/FeaturesSection";
import { HeroButton } from "@/components/home/HeroButton";
import { StarRatings } from "@/components/home/StarRatings";
import StepsSection from "@/components/home/StepsSection";
import Testimonials from "@/components/home/Testimonials";
import FAQ from "@/components/shared/FAQ";
import Footer from "@/components/shared/Footer";
import HeroSection from "@/components/shared/HeroSection";
import { CDN_URL } from "@/consts";
import { TRACKING_EVENTS } from "@/consts/tracking";
import * as amplitude from "@amplitude/analytics-browser";
import Image from "next/image";
import { useRouter } from "next/router";
import { useEffect } from "react";

const heading = (
  <h1 className="text-center text-[31px] font-semibold text-gray-900 md:text-balance md:text-7xl md:tracking-[0.015em]">
    The{" "}
    <span className="relative inline-block max-w-fit rounded-lg bg-[#335CFF] p-1 text-white sm:p-2">
      #1 Clipping Tool
      <Image
        src={`${CDN_URL}/landing/trusted-by-desktop.png`}
        alt="Crayo Logo"
        width={321}
        height={237}
        draggable={false}
        className="absolute -right-3 top-2 max-h-[140px] w-auto -translate-y-1/2 translate-x-full select-none max-xl:hidden"
      />
    </span>
    <br />
    Edit Viral Videos With AI
  </h1>
);
const body =
  "Your all-in-one tool for creating AI voiceovers, engaging subtitles, optimized gameplay, and more.";
const mobileBody = "Your all-in-one platform for editing.";

const Home = () => {
  const router = useRouter();
  useEffect(() => {
    if (router.isReady) {
      amplitude.track(TRACKING_EVENTS.LANDING.LANDING_HIT, {
        path: router.asPath,
      });
    }
  }, [router.isReady, router.asPath]);
  return (
    <div className="flex size-full flex-col overflow-hidden bg-white transition-all duration-200 ease-in-out">
      <HeroSection
        topComponent={<StarRatings className="bg-transparent" textColor="text-[#1355FF]" />}
        heading={heading}
        body={body}
        mobileBody={mobileBody}
        button={<HeroButton />}
        wrapperStyle="gap-6 lg:gap-8"
      />
      <StepsSection />
      <EditorDemoSection />
      <FeaturesBento />
      {/* <AutoClipperSection /> */}
      <Testimonials />
      <CoFounder />
      <FAQ />
      <Footer />
    </div>
  );
};

export default Home;
